export default "__VITE_ASSET__GnddiZZD__"